import React from "react"
import styled from "styled-components"

const Line = styled.div`
  height: 34px;
  width: 1px;
  border: 1px solid ${({theme}) => theme.colors.greys.medium};
`

const Divider: React.FC = () => <Line />

export default Divider
